/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import { string, number, date, array, object } from './utils'

export const getlistApplication = {
  Req: {
    "applicationYear": Number,
    "publishOrgName": String,
    "applicationName": String,
    "infoState": String,
    "publishOrgId": String,
    "bizLineCode": String,
    "bizTypeCode": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postaddApplication = {
  Req: {
    "applicationName": {
        "type": String,
        "required": true
    },
    "applicationYear": {
        "type": Number,
        "required": true
    },
    "publishOrgId": {
        "type": String,
        "required": true
    },
    "publishOrgName": String,
    "publisherId": {
        "type": String,
        "required": true
    },
    "publisherName": String,
    "publisherEmail": String,
    "publisherContact": String,
    "applicationExplain": String,
    "applicationFileGroupId": String,
    "summaryDescription": String,
    "applicationDeadline": Date,
    "joinScopeOrgIds": {
        "type": Array,
        "required": true
    },
    "joinScopeOrgNames": {
        "type": Array,
        "required": true
    },
    "bizLineCode": {
        "type": String,
        "required": true
    },
    "bizTypeCode": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postaddApplicationObject = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "objectIds": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const deletedeleteApplicationObject = {
  Req: {
    "applicationObjectIds": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const puteditApplicationExplain = {
  Req: {
    "applicationObjectId": {
        "type": String,
        "required": true
    },
    "applicationExplain": {
        "type": String,
        "required": true
    },
    "applicationFileGroupId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putendAndArchive = {
  Req: {
    "applicationInfoIds": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putrevokeApplication = {
  Req: {
    "applicationInfoIds": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const deletedeleteApplication = {
  Req: {
    "applicationInfoIds": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistApplicationObject = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "objectName": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistReportRequest = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "orgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putpublishReportRequest = {
  Req: {
    "applicationInfoId": String,
    "joinOrgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const posteditReportRequest = {
  Req: {
    "requestId": String,
    "applicationObjectId": String,
    "orgId": String,
    "allowIndividual": String,
    "forceLimitTime": String,
    "forceLimitQuota": String,
    "allocateQuota": String,
    "reportTimeLimit": Date,
    "reportQuotaList": Array,
    "reportQuotaList[0]": Object,
    "reportQuotaList[0].quotaOrgId": String,
    "reportQuotaList[0].quotaOrgName": String,
    "reportQuotaList[0].orderNum": String,
    "reportQuotaList[0].allocateQuota": String,
    "reportQuotaList[0].requestId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetApplication = {
  Req: {
    "applicationInfoId": {
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistReportProjectList = {
  Req: {
    "reportListId": {
        "type": String,
        "required": true
    },
    "reportState": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistIndividualProjectSignUp = {
  Req: {
    "applicationObjectId": {
        "type": String,
        "required": true
    },
    "currentOrgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postaddToReportList = {
  Req: {
    "signUpIds": {
        "type": Array,
        "required": true
    },
    "applicationObjectId": {
        "type": String,
        "required": true
    },
    "orgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postremoveFormReportList = {
  Req: {
    "listItemIds": Array,
    "orgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postsubmitReportList = {
  Req: {
    "reportListId": {
        "type": String,
        "required": true
    },
    "reportOrgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postbatchAddOpinion = {
  Req: {
    "listItemIds": {
        "type": Array,
        "required": true
    },
    "opinion": {
        "type": String,
        "required": true
    },
    "decisionOrgName": String,
    "leaderId": String,
    "leaderName": String,
    "createTime": Date
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postbatchGradingProject = {
  Req: {
    "listItemIds": {
        "type": Array,
        "required": true
    },
    "rank": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postconfirmFinalResult = {
  Req: {
    "reportListId": {
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getexportReportList = {
  Req: {
    "reportListId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postreturnToModify = {
  Req: {
    "listItemId": {
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postsupplementJoinScope = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "joinScopeOrgIds": {
        "type": Array,
        "required": true
    },
    "joinScopeOrgNames": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistOrgApplication = {
  Req: {
    "applicationYear": Number,
    "publishOrgName": String,
    "applicationName": String,
    "infoState": String,
    "publishOrgId": String,
    "bizLineCode": String,
    "bizTypeCode": String,
    "joinOrgId": String,
    "publishState": String,
    "scopePublishState": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetReportRequest = {
  Req: {
    "requestId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetSubAndJoinOrgList = {
  Req: {
    "orgId": {
        "type": String,
        "required": true
    },
    "applicationInfoId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetReportListInfo = {
  Req: {
    "reportListId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistReportList = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "orgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getpreAddApplication = {
  Req: {
    "orgId": {
        "type": String,
        "required": true
    },
    "userId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postsortReportListItem = {
  Req: {
    "sourceId": {
        "type": String,
        "required": true
    },
    "targetId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistSubReportList = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "orgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putupdateApplication = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "applicationName": {
        "type": String,
        "required": true
    },
    "applicationYear": {
        "type": Number,
        "required": true
    },
    "publishOrgId": {
        "type": String,
        "required": true
    },
    "publishOrgName": String,
    "publisherId": {
        "type": String,
        "required": true
    },
    "publisherName": String,
    "publisherEmail": String,
    "publisherContact": String,
    "applicationExplain": String,
    "applicationFileGroupId": String,
    "summaryDescription": String,
    "applicationDeadline": Date,
    "joinScopeOrgIds": {
        "type": Array,
        "required": true
    },
    "joinScopeOrgNames": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistApplicationJoinScope = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetSubRequestIsPublish = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "orgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetApplicationObject = {
  Req: {
    "applicationObjectId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postsortApplicationObject = {
  Req: {
    "sourceId": {
        "type": String,
        "required": true
    },
    "targetId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postrevokePublishReportRequest = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "joinOrgId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistSubReportProjectList = {
  Req: {
    "orgId": {
        "type": String,
        "required": true
    },
    "applicationObjectId": {
        "type": String,
        "required": true
    },
    "currentOrgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putunlockApplication = {
  Req: {
    "applicationInfoIds": Array
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetSignUpId = {
  Req: {
    "listItemId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putupdateSummaryDescription = {
  Req: {
    "applicationInfoId": {
        "type": String,
        "required": true
    },
    "summaryDescription": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postgetTree = {
  Req: {
    "currentOrgId": {
        "type": String,
        "required": true
    },
    "applicationInfoId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetBasicForm = {
  Req: {
    "obejctId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}